import { get } from './api';
import routes from './end-points';

export const userfundsApi = {
  init: () => get(routes.userFunds.init),
};
